import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import BackHandIcon from "@mui/icons-material/BackHand";
import DoneIcon from "@mui/icons-material/Done";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import FlashOnOutlinedIcon from "@mui/icons-material/FlashOnOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import InfoIcon from "@mui/icons-material/Info";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { Button, Chip, Grid2 as Grid, Link, MenuItem, Select, Stack, Typography } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
  GridRowSelectionModel,
  GridRowsProp,
} from "@mui/x-data-grid-premium";
import { produce } from "immer";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { Link as RouterLink, useOutletContext } from "react-router";
import PageFilter from "../../../../Components/Misc/PageFilter";
import AssetStatus from "../../../../Components/Misc/Status/AssetStatus/asset-status";
import { ModalContext } from "../../../../Components/Modals";
import ModalSearchUser, {
  ModalSearchUserElementProps,
} from "../../../../Components/Modals/ModalSearchUser/modal-search-user";
import ModalWorkflowDetails, {
  ModalWorkflowDetailsElementProps,
} from "../../../../Components/Modals/ModalShowDetails/modal-workflow-details";
import AssetPanel from "../../../../Components/Panels/AssetPanel/asset-panel";
import DataTable, { CellSize } from "../../../../Components/Table/table";
import TableCellIngestPriorityChip from "../../../../Components/Table/TableCellIngestPriorityChip/table-cell-ingest-priority-chip";
import TableCellIngestStatus from "../../../../Components/Table/TableCellIngestStatus/table-cell-ingest-status";
import TableCellMovie from "../../../../Components/Table/TableCellMovie/table-cell-movie";
import TableCellOwner2Lines from "../../../../Components/Table/TableCellOwner2Lines/table-cell-owner-2-lines";
import TableCellTypography from "../../../../Components/Table/TableCellTypography/table-cell-typography";
import { EventNotifierOperation } from "../../../../Core/Api/notifier-client";
import { eventsNotifier, workflowService } from "../../../../Core/Api/services";
import { AclTypes } from "../../../../Core/Api/Types/acl-types";
import { DbUserBasicInfos } from "../../../../Core/Api/Types/db-user-basic-infos";
import { ObjectStatus } from "../../../../Core/Api/Types/object-status";
import { ObjectType } from "../../../../Core/Api/Types/object-type";
import { WorkflowFamily } from "../../../../Core/Api/Types/workflow-family";
import { WorkflowType } from "../../../../Core/Api/Types/workflow-type";
import { WorkflowProps, WorkflowRows } from "../../../../Core/Api/Workflow/workflow-api-service";
import GlobalConst from "../../../../Core/Utils/Constants/globals";
import { routePaths } from "../../../../Router/router";
import {
  AclMatch,
  GetEnumValueLabelMap,
  GetObjectStatusLabel,
  UserHasAcl,
  UserHasAcls,
} from "../../../../Utils/helpers";
import useCustomSnackbar from "../../../../Utils/Hooks/useCustomSnackbar";
import { useToggle } from "../../../../Utils/Hooks/useToggle";
import { IngestStatus } from "../../Ingest/IngestIndex/IngestProcessing/ingest-processing";
import { useTranslation } from "react-i18next";
import CachedOutlinedIcon from "@mui/icons-material/CachedOutlined";
import HourglassEmptyOutlinedIcon from "@mui/icons-material/HourglassEmptyOutlined";
import {
  CancelOutlined,
  EqualizerOutlined,
  ErrorOutline,
  PlayCircleOutlineOutlined,
  TaskAltOutlined,
  WorkspacesOutlined,
} from "@mui/icons-material";

function DashboardQC() {
  const { t } = useTranslation();
  const [searchFilter, setSearchFilter] = React.useState<string>("");
  const [typeFilter, setTypeFilter] = React.useState<string>("Default");
  const [claimFilter, setClaimFilter] = React.useState<string>("Default");
  const [workflowType, setWorkflowType] = React.useState<string>("Default");
  const [assetStatusFilter, setAssetStatusFilter] = React.useState<string>("Default");
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const [assetSelected, setAssetSelected] = React.useState<number>();
  const [rowSelected, setRowSelected] = React.useState<number>();
  const { active: assetPanel, toggle: toggleAssetPanelOpen } = useToggle(false);
  const [workflowId, setWorkflowId] = React.useState<number>();

  const [workflowStatusFilter, setWorkflowStatusFilter] = useState<IngestStatus>();

  // Table rows
  const [rows, setRows] = useState<WorkflowRows[]>([]);

  // Box filters
  const [countInstances, setCountInstances] = useState<WorkflowProps["countInstances"]>({
    countInstancesAccepted: 0,
    countInstancesProcessing: 0,
    countInstancesPendingQC: 0,
    countInstancesRejected: 0,
    countInstancesError: 0,
    countInstancesWaitingMezz: 0,
    countInstancesQcInProgress: 0,
    countInstancesMissingMetadata: 0,
  });

  const aclQcCheck = UserHasAcls([AclTypes.aclSuperUser, AclTypes.aclUserTaskUpdate], AclMatch.OneAtLeast);
  const aclPriority = UserHasAcl(AclTypes.aclIngestAssignPriority);
  const aclPlayWorkflow = UserHasAcl(AclTypes.aclBackofficeWorkflowAdmin);

  const modalContext = React.useContext(ModalContext);
  const { openModal } = { ...modalContext };

  const xsValue = 12 / 8;

  const enqueueCustomSnackbar = useCustomSnackbar();
  const { selectedItems: selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<any[]>>;
    selectedItems: any[];
  }>();

  const handleOpenModalDetails = (data) => {
    if (!openModal) return;
    const onClose: ModalWorkflowDetailsElementProps["onClose"] = (data) => {};

    openModal<ModalWorkflowDetailsElementProps>(ModalWorkflowDetails, {
      onClose,
      workflow: data,
    });
  };

  const handleOpenModalSearchUser = (id: number) => {
    if (!openModal) return;
    const onClose: ModalSearchUserElementProps["onClose"] = (data) => {};

    setWorkflowId(id);

    openModal<ModalSearchUserElementProps>(ModalSearchUser, {
      onClose,
      onConfirm: handleAssignClick,
      title: t("modal:title.assignUserToWorkflow"),
    });
  };

  // Box filters
  const changeStatusFilter = (statuses: IngestStatus) => {
    // if click on same filter
    if (statuses === workflowStatusFilter) {
      setWorkflowStatusFilter(undefined);
      return;
    }

    setWorkflowStatusFilter(statuses);
  };

  const handleClaimClick = (id: number) => {
    workflowService.ClaimUserTask(id).then(function (response) {
      if (response.success) {
        enqueueCustomSnackbar(t("alert:success.workflowClaimed"), "success");
        workflowService.GetInstanceById(id).then(function (response) {
          if (response.success && response.instance) {
            setRows(
              rows.map((data) => {
                if (data.id === id) {
                  return workflowService.GetWorkflowsComputed(response.instance?.workflow!);
                } else return data;
              })
            );
          }
        });
      }
    });
  };

  const handleAssignClick = (user: DbUserBasicInfos) => {
    if (workflowId)
      workflowService.ClaimUserTaskByUserId(workflowId, user.id).then(function (response) {
        if (response.success) {
          enqueueCustomSnackbar(t("alert:success.workflowAssigned"), "success");
          workflowService.GetInstanceById(workflowId).then(function (response) {
            if (response.success && response.instance) {
              setRows(
                rows.map((data) => {
                  if (data.id === workflowId) {
                    return workflowService.GetWorkflowsComputed(response.instance?.workflow!);
                  } else return data;
                })
              );
            }
          });
        }
      });
  };

  React.useEffect(() => {
    const qcResponse = workflowService.GetWorkflowsByFamily(WorkflowFamily.QualityCheck);
    const ingestResponse = workflowService.GetWorkflowsByFamily(WorkflowFamily.Ingest);

    Promise.all([qcResponse, ingestResponse]).then(function (result) {
      setCountInstances({
        countInstancesAccepted:
          result[0].countInstances.countInstancesAccepted + result[1].countInstances.countInstancesAccepted,
        countInstancesError:
          result[0].countInstances.countInstancesError + result[1].countInstances.countInstancesError,
        countInstancesPendingQC:
          result[0].countInstances.countInstancesPendingQC + result[1].countInstances.countInstancesPendingQC,
        countInstancesProcessing:
          result[0].countInstances.countInstancesProcessing + result[1].countInstances.countInstancesProcessing,
        countInstancesQcInProgress:
          result[0].countInstances.countInstancesQcInProgress + result[1].countInstances.countInstancesQcInProgress,
        countInstancesRejected:
          result[0].countInstances.countInstancesRejected + result[1].countInstances.countInstancesRejected,
        countInstancesWaitingMezz:
          result[0].countInstances.countInstancesWaitingMezz + result[1].countInstances.countInstancesWaitingMezz,
        countInstancesMissingMetadata:
          result[0].countInstances.countInstancesMissingMetadata +
          result[1].countInstances.countInstancesMissingMetadata,
      });
      setRows(result[0].rows.concat(result[1].rows));
      setIsLoading(false);
    });

    eventsNotifier.Connect().then(function (result) {
      console.debug("Hub events connected successfully to WebSocket and is listening to WorkflowInstanceMessage!");
      if (eventsNotifier.connection)
        eventsNotifier.connection.on("WorkflowInstanceMessage", (data) => {
          switch (data.op) {
            case EventNotifierOperation.Create:
              let instanceComputedForCreation = workflowService.GetWorkflowsComputed(data.data);
              if (
                data.data.definitionFamily === WorkflowFamily.QualityCheck ||
                instanceComputedForCreation.status === IngestStatus.PendingQC
              ) {
                // add row to table
                setRows(
                  produce((draft) => {
                    draft.push(instanceComputedForCreation);
                  })
                );
                setCountInstances(
                  produce((draft) => {
                    switch (instanceComputedForCreation.status) {
                      case IngestStatus.Accepted:
                        draft.countInstancesAccepted++;
                        break;
                      case IngestStatus.Running:
                        draft.countInstancesProcessing++;
                        break;
                      case IngestStatus.PendingQC:
                        draft.countInstancesPendingQC++;
                        break;
                      case IngestStatus.Rejected:
                        draft.countInstancesRejected++;
                        break;
                      case IngestStatus.WorkflowError:
                        draft.countInstancesError++;
                        break;
                      case IngestStatus.WaitingMezz:
                        draft.countInstancesWaitingMezz++;
                        break;
                      case IngestStatus.QcInProgress:
                        draft.countInstancesWaitingMezz++;
                        break;
                      case IngestStatus.MissingMetadata:
                        draft.countInstancesMissingMetadata++;
                        break;
                    }
                  })
                );
              }

              break;
            case EventNotifierOperation.Update:
              let instanceComputedForUpdate = workflowService.GetWorkflowsComputed(data.data);
              if (
                data.data.definitionFamily === WorkflowFamily.QualityCheck ||
                instanceComputedForUpdate.status === IngestStatus.PendingQC
              ) {
                // update rows
                setRows(
                  produce((draft) => {
                    const index = draft.findIndex((x) => x.id === instanceComputedForUpdate.id);
                    if (index !== -1) draft[index] = instanceComputedForUpdate;
                  })
                );
              }
              //TODO : update CountInstances
              break;
            case EventNotifierOperation.Delete:
              let instanceComputedForDeletion = workflowService.GetWorkflowsComputed(data.data);
              if (
                data.data.definitionFamily === WorkflowFamily.QualityCheck ||
                instanceComputedForDeletion.status === IngestStatus.PendingQC
              ) {
                // delete row from table
                setRows(
                  produce((draft) => {
                    const index = draft.findIndex((x) => x.id === data.data.id);
                    if (index !== -1) draft.splice(index, 1);
                  })
                );
                setCountInstances(
                  produce((draft) => {
                    switch (instanceComputedForDeletion.status) {
                      case IngestStatus.Accepted:
                        draft.countInstancesAccepted--;
                        break;
                      case IngestStatus.Running:
                        draft.countInstancesProcessing--;
                        break;
                      case IngestStatus.PendingQC:
                        draft.countInstancesPendingQC--;
                        break;
                      case IngestStatus.Rejected:
                        draft.countInstancesRejected--;
                        break;
                      case IngestStatus.WorkflowError:
                        draft.countInstancesError--;
                        break;
                      case IngestStatus.WaitingMezz:
                        draft.countInstancesWaitingMezz--;
                        break;
                      case IngestStatus.QcInProgress:
                        draft.countInstancesWaitingMezz--;
                        break;
                      case IngestStatus.MissingMetadata:
                        draft.countInstancesMissingMetadata--;
                        break;
                    }
                  })
                );
              }
              break;
          }
        });
    });

    return function cleanUp() {
      eventsNotifier.Disconnect();
    };
  }, []);

  const handleSetPriority = (instanceId: number, priority: number) => {
    workflowService.SetPriorityOnInstanceById(instanceId, priority).then(() => {
      enqueueCustomSnackbar(t("alert:success.prioritySetOnWorkflow"), "success");
    });
  };

  const handleSetPriorityHigh = (instanceId: number) => {
    handleSetPriority(instanceId, 60);
  };

  const handleSetPriorityNormal = (instanceId: number) => {
    handleSetPriority(instanceId, 50);
  };

  const handleSetPriorityLow = (instanceId: number) => {
    handleSetPriority(instanceId, 40);
  };

  // #region Grid definition
  type ValidRow = (typeof rows)[number];
  type ValidField = keyof ValidRow;
  type ColumnWithValidField = { field: ValidField };
  let _rows: GridRowsProp = [];
  type Row = (typeof _rows)[number];

  const columns: GridColDef<WorkflowRows>[] = React.useMemo(
    () => [
      {
        field: "assetId",
        headerName: t("common:assetId"),
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        renderCell: (data) => (
          <Link underline="hover" to={`${routePaths.asset.path}/${data.value}`} component={RouterLink} target="_blank">
            {data.value}
          </Link>
        ),
      },
      {
        field: "assetParentTitleName",
        headerName: t("common:title"),
        flex: CellSize.large,
        minWidth: CellSize.large,
        valueGetter: (value, row) => row.assetParentTitleName,
        renderCell: (data) => {
          if (data.row.assetParentTitleId && data.row.assetParentTitleName) {
            return <TableCellMovie id={data.row.assetParentTitleId} name={data.row.assetParentTitleName} />;
          } else {
            return <></>;
          }
        },
      },
      {
        field: "startTime",
        headerName: t("common:upperCaseCreation"),
        type: "date",
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        valueGetter: (value, row) => (row.startTime ? new Date(row.startTime) : null),
        renderCell: (data) => (
          <TableCellOwner2Lines
            userName={data.row.createdByUserName}
            groupName={data.value ? moment(data.value).format(GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS) : "-"}
          />
        ),
      },
      {
        field: "type",
        headerName: t("common:type"),
        flex: CellSize.small,
        minWidth: CellSize.small,
        type: "singleSelect",
        valueOptions: [WorkflowType.Qualify, WorkflowType.QualityCheck],
        renderCell: (data) => {
          return data.value === "Qualify" ? (
            <Chip icon={<ReportGmailerrorredOutlinedIcon />} label="Q" color="warning" />
          ) : (
            <Chip icon={<FlashOnOutlinedIcon />} label="QC" color="info" />
          );
        },
      },
      {
        field: "providerName",
        headerName: t("common:provider"),
        flex: CellSize.small,
        minWidth: CellSize.small,
        renderCell: (data) => <Typography>{data.value || "-"}</Typography>,
      },
      {
        field: "asset",
        headerName: t("common:assetUpperCase"),
        flex: CellSize.xlarge,
        minWidth: CellSize.xlarge,
        valueGetter: (value, row) => row.asset?.name ?? row.assetName,
        renderCell: (data) => <TableCellTypography data={data.value} variant="body2" />,
      },
      {
        field: "status",
        headerName: t("common:status"),
        type: "singleSelect",
        valueOptions: Object.keys(IngestStatus).map((x) => IngestStatus[x]),
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        valueFormatter: (params: any, row: any) => {
          return params ?? "";
        },
        renderCell: (data) => <TableCellIngestStatus data={data} />,
      },
      {
        field: "annotation",
        headerName: t("common:message"),
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        renderCell: (data) => <TableCellTypography data={data.value} variant="body2" />,
      },
      /*{
              field: "currentTaskName",
              headerName: "Current Task",
              width: 140,
              renderCell: (data: Row) => (
                <Link
                  onClick={(e) => {
                    handleOpenModalDetails(data.row);
                    e.stopPropagation();
                  }}
                  underline="hover"
                >
                  {data.value}
                </Link>
              ),
            },*/
      /*{
              field: "progress",
              headerName: "Progress",
              width: 150,
              renderCell: (data: Row) => <TableCellProgressBar progress={data.value} />,
            },*/
      {
        field: "userTasks",
        headerName: t("common:claimed"),
        type: "boolean",
        valueGetter: (data: Row, row: any) =>
          row?.userTasks !== null &&
          row?.userTasks[0].claimInfos !== null &&
          row?.userTasks[0].claimInfos.userName !== "",
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        renderCell: (data) => {
          if (
            data?.row?.userTasks !== null &&
            data?.row?.userTasks[0].claimInfos !== null &&
            data?.row?.userTasks[0].claimInfos.userName !== ""
          )
            return (
              <Stack direction="row" alignItems="center" spacing={0.5}>
                {data?.row?.userTasks[0].claimInfos.userName}
              </Stack>
            );
          else
            return (
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={(e) => {
                    handleClaimClick(data.row["id"]);
                    e.stopPropagation();
                  }}
                  disabled={!aclQcCheck}
                  size="small"
                  startIcon={<BackHandIcon />}
                >
                  {t("common:claim")}
                </Button>
              </Stack>
            );
        },
      },
      {
        field: "assetStatus",
        headerName: t("common:assetStatus"),
        type: "singleSelect",
        valueOptions: GetEnumValueLabelMap(ObjectStatus, GetObjectStatusLabel),
        flex: CellSize.medium,
        minWidth: CellSize.medium,
        valueGetter: (value, row) => row.asset?.status,
        renderCell: (data) => <AssetStatus status={data.value} />,
      },
      {
        field: "priority",
        headerName: t("common:priority"),
        flex: CellSize.xsmall,
        minWidth: CellSize.xsmall,
        type: "singleSelect",
        valueOptions: ["Normal", "High", "Critical"],
        valueGetter: (value, row) => {
          if (row.priority <= 50) {
            return "Normal";
          } else if (row?.priority > 50 && row?.priority < 75) {
            return "High";
          } else {
            return "Critical";
          }
        },
        renderCell: (data: Row) => <TableCellIngestPriorityChip data={{ ...data, value: data?.row?.priority }} />,
      },
      {
        headerName: "",
        field: "actions",
        type: "actions",
        align: "right",
        flex: CellSize.actionsSmall,
        minWidth: CellSize.actionsSmall,
        getActions: (params: GridRowParams) => {
          if (!params || !params.row) return [];
          const priority = params.row["priority"];
          const setPriorityHighButton = (
            <GridActionsCellItem
              icon={<ArrowUpwardIcon />}
              label={t("table:cellLabel.setPriorityHigh")}
              onClick={() => handleSetPriorityHigh(params.row["id"])}
              showInMenu
              disabled={!aclPriority}
            />
          );
          const setPriorityNormalButton = (
            <GridActionsCellItem
              icon={<ArrowForwardIcon />}
              label={t("table:cellLabel.setPriorityNormal")}
              onClick={() => handleSetPriorityNormal(params.row["id"])}
              showInMenu
              disabled={!aclPriority}
            />
          );
          const setPriorityLowButton = (
            <GridActionsCellItem
              icon={<ArrowDownwardIcon />}
              label={t("table:cellLabel.setPriorityLow")}
              onClick={() => handleSetPriorityLow(params.row["id"])}
              showInMenu
              disabled={!aclPriority}
            />
          );
          const buttons = [
            <GridActionsCellItem
              icon={<GroupsOutlinedIcon />}
              label={t("table:cellLabel.assign")}
              color="info"
              onClick={(e) => {
                handleOpenModalSearchUser(params.row["id"]);
                e.stopPropagation();
              }}
              disabled={
                (params.row["userTasks"] !== null &&
                  params.row["userTasks"][0].claimInfos !== null &&
                  params.row["userTasks"][0].claimInfos.userName !== "") ||
                !aclQcCheck
              }
              showInMenu
            />,
            <GridActionsCellItem
              icon={<InfoIcon />}
              label={t("common:infos")}
              color="info"
              onClick={(e) => {
                handleOpenModalDetails(params.row);
                e.stopPropagation();
              }}
              showInMenu
            />,
          ];

          if (priority < 50) {
            buttons.push(setPriorityHighButton, setPriorityNormalButton);
          } else if (priority > 50) {
            buttons.push(setPriorityNormalButton, setPriorityLowButton);
          } else {
            buttons.push(setPriorityHighButton, setPriorityLowButton);
          }

          if (aclPlayWorkflow && params?.row?.status === IngestStatus.Ready) {
            buttons.push(
              <GridActionsCellItem
                icon={<PlayCircleOutlineOutlined />}
                label={t("common:play")}
                color="info"
                onClick={(e) =>
                  workflowService.PlayInstance(params?.row?.id).then((response) => {
                    if (response.success) {
                      enqueueCustomSnackbar(t("alert:success.workflowPlayed", { id: params?.row?.id }), "success");
                    } else {
                      enqueueCustomSnackbar(
                        t("alert:warning.workflowWasNotPlayed", { id: params?.row?.id, message: response.message }),
                        "warning"
                      );
                    }
                  })
                }
                showInMenu
              />
            );
          }

          return buttons;
        },
      },
    ],
    [rows]
  );

  const openAssetPanel = (row) => {
    setAssetSelected(row.row.assetId);
    setRowSelected(row.row.id);
    if (!assetPanel) toggleAssetPanelOpen();
  };

  const handleSelectionChange = (newSelectedRows: GridRowSelectionModel) => {
    const selectedIds = newSelectedRows as number[];
    setSelectedItems(rows.filter((x) => selectedIds.includes(x.id)));
  };

  const filteredRows = useMemo(() => {
    let output = rows;

    if (searchFilter !== "") {
      output = output.filter(
        (row) =>
          row.createdByUserName?.includesAllWords(searchFilter) ||
          row.providerName.includesAllWords(searchFilter) ||
          row.asset?.parentTitleName?.includesAllWords(searchFilter) ||
          row.assetId.toString().includesAllWords(searchFilter)
      );
    }

    if (typeFilter !== "Default") {
      output = output.filter((row) => row.assetType === typeFilter);
    }

    if (assetStatusFilter !== "Default") {
      output = output.filter((row) => row.status === assetStatusFilter);
    }

    if (claimFilter === "Yes") {
      output = output.filter(
        (row) =>
          row.userTasks !== null && row.userTasks[0].claimInfos !== null && row.userTasks[0].claimInfos.userName !== ""
      );
    } else if (claimFilter === "No") {
      output = output.filter(
        (row) =>
          row.userTasks === null ||
          row.userTasks.length === 0 ||
          row.userTasks[0].claimInfos === null ||
          row.userTasks[0].claimInfos.userName === ""
      );
    }

    if (workflowType !== "Default") {
      output = output.filter((row) => row.type === workflowType);
    }

    if (workflowStatusFilter) {
      if (workflowStatusFilter === IngestStatus.WorkflowError) {
        output = output.filter(
          (row) =>
            row.status === IngestStatus.WorkflowError ||
            row.status === IngestStatus.Aborted ||
            row.status === IngestStatus.Cancelled
        );
      } else if (workflowStatusFilter === IngestStatus.Running) {
        output = output.filter(
          (row) => row.status === IngestStatus.Running || row.status === IngestStatus.QcInProgress
        );
      } else {
        output = output.filter((row) => row.status === workflowStatusFilter);
      }
    }

    return output;
  }, [rows, searchFilter, typeFilter, assetStatusFilter, claimFilter, workflowType, workflowStatusFilter]);

  const additionalFilters = (
    <>
      <Select
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        startAdornment={<FlashOnOutlinedIcon />}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={workflowType}
        onChange={(e) => setWorkflowType((e.target.value as string) || "Default")}
      >
        <MenuItem value={"Default"}>{t("common:type")}</MenuItem>
        <MenuItem value={"Qualify"}>{t("common:qualify")}</MenuItem>
        <MenuItem value={"QualityCheck"}>{t("menu:item.qualityCheck")}</MenuItem>
      </Select>
      <Select
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        startAdornment={<WorkspacesOutlined />}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={typeFilter}
        onChange={(e) => setTypeFilter(ObjectType[e.target.value as string] || "Default")}
      >
        <MenuItem value={"Default"}>{t("common:assetType")}</MenuItem>
        {Object.keys(ObjectType)
          .sort()
          .map((type, index) => (
            <MenuItem value={type} key={index}>
              {type}
            </MenuItem>
          ))}
      </Select>
      <Select
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        startAdornment={<EqualizerOutlined />}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={assetStatusFilter}
        onChange={(e) => setAssetStatusFilter(ObjectStatus[e.target.value as string] || "Default")}
      >
        <MenuItem value={"Default"}>{t("menu:item.assetStatus")}</MenuItem>
        {Object.keys(ObjectStatus)
          .sort()
          .map((type, index) => (
            <MenuItem value={type} key={index}>
              {GetObjectStatusLabel(type as ObjectStatus)}
            </MenuItem>
          ))}
      </Select>
      <Select
        displayEmpty
        IconComponent={ExpandMoreRoundedIcon}
        startAdornment={<DoneIcon />}
        inputProps={{ "aria-label": "Without label" }}
        MenuProps={{ PaperProps: { sx: { maxHeight: 600 } } }}
        value={claimFilter}
        onChange={(e) => setClaimFilter((e.target.value as string) || "Default")}
      >
        <MenuItem value={"Default"}>{t("menu:item.assetClaimedStatus")}</MenuItem>
        <MenuItem value={"Yes"}>{t("common:claimed")}</MenuItem>
        <MenuItem value={"No"}>{t("menu:item.notClaimed")}</MenuItem>
      </Select>
    </>
  );

  return (
    <>
      <Grid container spacing={1} sx={{ py: 2 }}>
        <Grid size={xsValue}>
          <PageFilter
            variant="primary"
            title={countInstances.countInstancesProcessing}
            subtitle={t("common:processing")}
            icon={<CachedOutlinedIcon />}
            active={workflowStatusFilter === IngestStatus.Running}
            onClick={() => changeStatusFilter(IngestStatus.Running)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="warning"
            title={countInstances.countInstancesPendingQC}
            subtitle={t("common:pendingQc")}
            icon={<RemoveRedEyeOutlinedIcon />}
            active={workflowStatusFilter === IngestStatus.PendingQC}
            onClick={() => changeStatusFilter(IngestStatus.PendingQC)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="primary"
            title={countInstances.countInstancesQcInProgress}
            subtitle={t("page:pageFilter.subTitle.qcInProgress")}
            icon={<RemoveRedEyeOutlinedIcon />}
            active={workflowStatusFilter === IngestStatus.QcInProgress}
            onClick={() => changeStatusFilter(IngestStatus.QcInProgress)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="info"
            title={countInstances.countInstancesWaitingMezz}
            subtitle={t("common:waitingForMezz")}
            icon={<HourglassEmptyOutlinedIcon />}
            active={workflowStatusFilter === IngestStatus.WaitingMezz}
            onClick={() => changeStatusFilter(IngestStatus.WaitingMezz)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="warning"
            title={countInstances.countInstancesMissingMetadata}
            subtitle={t("common:missingMetadata")}
            icon={<ReportProblemOutlinedIcon />}
            active={workflowStatusFilter === IngestStatus.MissingMetadata}
            onClick={() => changeStatusFilter(IngestStatus.MissingMetadata)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="success"
            title={countInstances.countInstancesAccepted}
            subtitle={t("common:accepted")}
            icon={<TaskAltOutlined />}
            active={workflowStatusFilter === IngestStatus.Accepted}
            onClick={() => changeStatusFilter(IngestStatus.Accepted)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="error"
            title={countInstances.countInstancesRejected}
            subtitle={t("common:rejected")}
            icon={<CancelOutlined />}
            active={workflowStatusFilter === IngestStatus.Rejected}
            onClick={() => changeStatusFilter(IngestStatus.Rejected)}
          />
        </Grid>
        <Grid size={xsValue}>
          <PageFilter
            variant="error"
            title={countInstances.countInstancesError}
            subtitle={t("common:errors")}
            icon={<ErrorOutline />}
            active={workflowStatusFilter === IngestStatus.WorkflowError}
            onClick={() => changeStatusFilter(IngestStatus.WorkflowError)}
          />
        </Grid>
      </Grid>

      <DataTable
        loading={isLoading}
        rows={filteredRows}
        columns={columns}
        additionalFilters={additionalFilters}
        getRowId={(row) => row.id}
        getRowHeight={() => "auto"}
        columnHeaderHeight={48}
        onRowClick={(e) => openAssetPanel(e)}
        initialState={{
          sorting: { sortModel: [{ field: "startTime", sort: "desc" }] },
        }}
        checkboxSelection
        selectedRows={selectedItems.map((x) => x.id)}
        onRowSelectionModelChange={handleSelectionChange}
        disableRowSelectionOnClick
      />
      <AssetPanel
        open={assetPanel}
        onClose={toggleAssetPanelOpen}
        closePanel={toggleAssetPanelOpen}
        assetId={assetSelected}
        reload={rowSelected}
      />
    </>
  );
}

export default DashboardQC;
